import styled from '@emotion/styled';

import { Grid } from '@s_mart/core';

export const GridAcoes = styled(Grid)`
  display: flex;
  justify-content: center;
`;
